import React from "react";
import Apple_logo from "../images/apple_icon.svg";
import Google_logo from "../images/google_icon.svg";
import fb_logo from "../images/fb_icon.svg";
import { getThirdPartyAuthorisationURLWithQueryParamsAndSetState } from "supertokens-web-js/recipe/thirdpartypasswordless";
import { toast } from "react-toastify";

export default function SocialLogin({ setIsDisableButton }) {
  async function googleSignInClicked() {
    setIsDisableButton(true);
    try {
      const authUrl =
        await getThirdPartyAuthorisationURLWithQueryParamsAndSetState({
          thirdPartyId: "google",

          // This is where Google should redirect the user back after login or error.
          // This URL goes on the Google's dashboard as well.
          frontendRedirectURI: `${process.env.REACT_APP_BASE_URL}/auth/callback/google`,
          // frontendRedirectURI: "http://<YOUR_WEBSITE_DOMAIN>/auth/callback/google",
        });

      /*
        Example value of authUrl: https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&access_type=offline&include_granted_scopes=true&response_type=code&client_id=1060725074195-kmeum4crr01uirfl2op9kd5acmi9jutn.apps.googleusercontent.com&state=5a489996a28cafc83ddff&redirect_uri=https%3A%2F%2Fsupertokens.io%2Fdev%2Foauth%2Fredirect-to-app&flowName=GeneralOAuthFlow
        */

      // we redirect the user to google for auth.
      window.location.assign(authUrl);
    } catch (err) {
      console.log("err", err);
      if (err.isSuperTokensGeneralError === true) {
        // this may be a custom error message sent from the API by you.
        toast.error(err.message);
      } else {
        toast.error("Oops! Something went wrong.");
      }
    } finally {
      setIsDisableButton(false);
    }
  }
  async function facebookSignInClicked() {
    setIsDisableButton(true);
    try {
      const authUrl =
        await getThirdPartyAuthorisationURLWithQueryParamsAndSetState({
          thirdPartyId: "facebook",

          // This is where Google should redirect the user back after login or error.
          // This URL goes on the Google's dashboard as well.
          frontendRedirectURI: `${process.env.REACT_APP_BASE_URL}/auth/callback/facebook`,
          // frontendRedirectURI: "http://<YOUR_WEBSITE_DOMAIN>/auth/callback/google",
        });

      // we redirect the user to google for auth.
      window.location.assign(authUrl);
    } catch (err) {
      console.log("err", err);
      if (err.isSuperTokensGeneralError === true) {
        // this may be a custom error message sent from the API by you.
        toast.error(err.message);
      } else {
        toast.error("Oops! Something went wrong.");
      }
    } finally {
      setIsDisableButton(false);
    }
  }
  async function appleSignInClicked() {
    setIsDisableButton(true);
    try {
      const authUrl =
        await getThirdPartyAuthorisationURLWithQueryParamsAndSetState({
          thirdPartyId: "apple",

          frontendRedirectURI: `${process.env.REACT_APP_BASE_URL}/auth/callback/apple`, // This is an example callback URL on your frontend. You can use another path as well.
          redirectURIOnProviderDashboard: `${process.env.REACT_APP_API_BASE_URL}/auth/callback/apple`, // This URL goes on the Apple's dashboard
        });

      // we redirect the user to apple for auth.
      window.location.assign(authUrl);
    } catch (err) {
      console.log("err", err);
      if (err.isSuperTokensGeneralError === true) {
        // this may be a custom error message sent from the API by you.
        toast.error(err.message);
      } else {
        toast.error("Oops! Something went wrong.");
      }
    } finally {
      setIsDisableButton(false);
    }
  }
  return (
    <div className="flex justify-center w-full p-2.5 pb-3 px-8">
      <div className="w-7/12 flex flex-row justify-center items-center gap-[8px] lg:w-10/12 md:w-full sm:w-[70%] xs:w-full">
        {/* Temporarily disable apple social login */}
        {false && (
          <button
            className="flex justify-center items-center h-full bg-transparent border border-solid border-gray-300 w-1/3 py-2.5 rounded-md shadow-sm cursor-pointer disabled:pointer-events-none"
            onClick={appleSignInClicked}
            type="button"
          >
            <img src={Apple_logo} alt="apple" />
          </button>
        )}
        <button
          className="flex justify-center items-center h-full bg-transparent border border-solid border-gray-300 w-1/3 py-2.5  rounded-md shadow-sm cursor-pointer disabled:pointer-events-none"
          onClick={googleSignInClicked}
          type="button"
        >
          <img src={Google_logo} alt="google" />
        </button>
        {/* <button
          className="flex justify-center items-center bg-transparent border border-solid border-gray-300 w-1/3 py-2.5 rounded-md shadow-sm cursor-pointer disabled:pointer-events-none"
          onClick={facebookSignInClicked}
          type="button"
        >
          <img src={fb_logo} alt="facebook" />
        </button> */}
      </div>
    </div>
  );
}
